import TenantLeaseHistory from './TenantLeaseHistory'

export default TenantLeaseHistory
